export default "__VITE_ASSET__Pyh4XH8G__"